import React from 'react';
import { T } from '@/components/T';
import i18n from 'i18next';
import { useNavigate } from 'react-router-dom';

const FaqList = ({ faqs, setSelectedId }) => {
  const navigate = useNavigate();

  const renderItem = (item) => {
    // keeping your existing parsing (even though it isn't used here)
    const answerParagrahps =
      item.answer && item.answer.match(/^.*?<p>(.*?)<\/p>/);
    const parsedAnswer = Array.isArray(answerParagrahps)
      ? answerParagrahps[1]
      : null;

    return (
      <li
        key={item.id}
        className="mt-1 cursor-pointer"
        onClick={() => {
          navigate(
            `${i18n?.language ? '/' + i18n.language : ''}/help/faqs/` + item.id
          );
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 0);
        }}
      >
        <div className="flex items-center gap-2">
          <div className="search-result-list-item-question">
            {item.question}
          </div>

          {!item.validated && (
            <span className="rounded bg-orange-100 px-2 py-0.5 text-xs font-medium text-orange-700">
              <T>pages.faq.unvalidated</T>
            </span>
          )}
        </div>
      </li>
    );
  };

  return (
    <>
      {faqs.length > 0 && (
        <ol className="mx-8 my-0 mb-4 flex flex-col p-0">
          {faqs.map(renderItem)}
        </ol>
      )}
    </>
  );
};

export { FaqList };
